import React from 'react';

interface AcpFurtherInformationProps {
  acpFurtherInformation: string;
  setAcpFurtherInformation: (info: string) => void;
}

const AcpFurtherInformation: React.FC<AcpFurtherInformationProps> = ({
  acpFurtherInformation,
  setAcpFurtherInformation,
}) => {
  return (
    <div className="govuk-form-group">
      <label className="govuk-label" htmlFor="further-acp-infor">
        Information and details about the previously created Advance Care Plans
      </label>
      <textarea
        className="govuk-textarea"
        id="further-acp-infor"
        name="acpFurtherInformation"
        rows={5}
        aria-describedby="more-detail-hint"
        placeholder="Enter additional details here..."
        value={acpFurtherInformation}
        onChange={e => setAcpFurtherInformation(e.target.value)}
      />
    </div>
  );
};

export default AcpFurtherInformation;
